import {useState} from "react";
import {Modal,Image,Button} from "antd";
import {RightOutlined, LeftOutlined} from "@ant-design/icons";

export const Gallery = ({images,isModalOpen,setIsModalOpen}) => {

    // eslint-disable-next-line
    const [index,setIndex] = useState(0);

    const handlePrev = () => {
        if (index > 0) {
            setIndex(index - 1);
        }
    };

    const handleNext = () => {
        if (index < images.length - 1) {
            setIndex(index + 1);
        }
    };

    return(
        <Modal
        open={isModalOpen} 
        onOk={() => setIsModalOpen(false)}
        onCancel={() => setIsModalOpen(false)}
        cancelButtonProps={{
            style:{
            display:"none",
            },
        }}
        >
            {images && images.length ? <div style={{ display: "flex", alignItems: "center" }}>
                <Button onClick={handlePrev} disabled={index === 0} style={{ marginRight:20 }}> 
                    <LeftOutlined/>
                </Button>
                <div style={{ flexGrow: 1, textAlign: "center" }}>
                    <Image src={images[index]} loading="lazy" />
                    <br/><br/>
                    <p>{index+1}/{images.length}</p>
                </div>
                <Button onClick={handleNext} disabled={index === images.length - 1} style={{ marginLeft:20 }}>
                    <RightOutlined/>
                </Button>
            </div> : null}
        </Modal>
    )
}